import { render, staticRenderFns } from "./fontodi.vue?vue&type=template&id=fcef67d2&scoped=true"
import script from "./fontodi.vue?vue&type=script&lang=js"
export * from "./fontodi.vue?vue&type=script&lang=js"
import style0 from "./fontodi.vue?vue&type=style&index=0&id=fcef67d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcef67d2",
  null
  
)

export default component.exports